/**
 * @file: Sample.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 留样管理
 */
import request from '@/utils/request'

/**
 * 添加留样信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function sampleAdd(data) {
  return request({
    type: 'biz',
    url: 'sample/add',
    method: 'post',
    data
  })
}

/**
 * 删除/批量删除留样信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function sampleDelete(data) {
  return request({
    type: 'biz',
    url: 'sample/delete',
    method: 'post',
    data
  })
}

/**
 * 获取留样信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function sampleGet(data) {
  return request({
    type: 'biz',
    url: 'sample/get',
    method: 'post',
    data
  })
}

/**
 * 分页获取留样信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function sampleListGet(data) {
  return request({
    type: 'biz',
    url: 'sample/list/get',
    method: 'post',
    data
  })
}

/**
 * 留样信息打印
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function samplePrintAdd(data) {
  return request({
    type: 'biz',
    url: 'sample/print/add',
    method: 'post',
    data
  })
}

/**
 * 修改留样信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function sampleUpdate(data) {
  return request({
    type: 'biz',
    url: 'sample/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Sample.js